import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TripOriginIcon(props: IconProps) {
    return <Icon {...props} iconKey={"trip_origin"}/>
}
